import React from 'react';
import { ListFieldSection } from '../../../../../Layout';
import { Field, NumericInput, RadioGroup } from '../../../../../Core';
import { WorksheetEquipmentDropdown } from '../../../../Core';
import { useSelector } from 'react-redux';
import deepEquals from 'Lib/Object/deepEquals';
import { createWashingSieveSizeSelector } from '../../../helpers';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from '../../../../Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { hasValue } from 'Lib/Any';
import { createSieveSizeGetter } from 'Data/ViewModels/Equipment/ISieveSize';

let WashingSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const washingSieveSize = useSelector(createWashingSieveSizeSelector(createWorksheetSelector!), deepEquals);

  const isGuardSieveUsed = useSelector(createWorksheetSelector!('Equipment.IsGuardSieveUsed')) as boolean;

  const isGuardSieveAllowed = useSelector(
    pipe(
      createWorksheetSelector!('Equipment.AllSieveSizes'),
      createSieveSizeGetter('0_075'),
      (s) =>
        hasValue(washingSieveSize) && hasValue(s) && Number(washingSieveSize!.Size!.value) <= Number(s!.Size!.value)
    )
  );

  const guardSieveMinimumSieveSize = useSelector(
    pipe(createWorksheetSelector!('Equipment.AllSieveSizes'), createSieveSizeGetter('0_425')),
    deepEquals
  );

  return (
    <>
      <ListFieldSection>
        <Field input={<NumericInput />} label="Soaking Period" name="Preparation.SoakingPeriod" />
        <Field
          input={<WorksheetEquipmentDropdown />}
          name="Equipment.WashingSieve"
          label="Washing Sieve"
          equipmentType="sieve"
          disabled={!hasValue(washingSieveSize)}
          queryParams={
            washingSieveSize && {
              SieveSize: `${washingSieveSize?.Size?.value} ${washingSieveSize?.Size?.uom}`,
            }
          }
        />
      </ListFieldSection>
      <ListFieldSection visible={isGuardSieveAllowed}>
        <Field
          input={<RadioGroup />}
          label={`Coarser Sieve Used over ${washingSieveSize?.Caption ?? 'Washing'} Sieve`}
          name="Equipment.IsGuardSieveUsed"
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          name="Equipment.GuardSieve"
          label="Guard Sieve"
          equipmentType="sieve"
          queryParams={
            guardSieveMinimumSieveSize && {
              SieveSize: {
                value: `${guardSieveMinimumSieveSize?.Size?.value} ${guardSieveMinimumSieveSize?.Size?.uom}`,
                operator: '>=',
              },
            }
          }
          visible={isGuardSieveUsed}
        />
      </ListFieldSection>
    </>
  );
};

WashingSection = withInjectedProps(WashingSection);

export default WashingSection;
export { WashingSection };
